import CountDown from "@/components/countdown/count-down.vue";

export default CountDown;